











import { Prop, Component, Vue } from "vue-property-decorator";

@Component
export default class VGridCell extends Vue {
  @Prop({ default: 1 }) span!: number;
  @Prop() start?: number;

  get gridColumn() {
    if (this.start) {
      return `${this.start} / span ${this.span}`;
    } else {
      return `span ${this.span}`;
    }
  }

  get style() {
    return {
      gridColumn: this.gridColumn
    };
  }
}
